module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-down-circle-16f5c96cad339da2de718701a8972832.svg";